import {
	createHook,
	createStore,
	createContainer,
	createDefaultEocWrapper,
} from '@atlassian/eoc-rss-helpers';

import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { emptyResource } from '../../../common/constants';
import type { StoreBaseContainerProps } from '../../../common/types';
import { actions } from './actions';
import type { TeamAdminStatusState } from './types';

export const initialState: TeamAdminStatusState = {
	teamAdminStatus: emptyResource,
};

const Store = createStore({ initialState, actions, name: 'team-admin-status' });

const TeamAdminStatusContainer = createContainer<
	TeamAdminStatusState,
	typeof actions,
	{ children?: React.ReactNode; isGlobal?: boolean }
>(Store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): StoreBaseContainerProps => {
			const { cloudId } = useTenantContext();
			return {
				cloudId,
			};
		},
	}),
});

const useTeamAdminStatus = createHook(Store);

const useIsTeamAdmin = createHook(Store, {
	selector: (state) => ({
		isTeamAdmin: state.teamAdminStatus.data?.isTeamAdmin,
	}),
});

export { useIsTeamAdmin, useTeamAdminStatus, TeamAdminStatusContainer };
